/**
 * 
 * Known Issues
 *  - Safari and Chrome do not include errored requests: https://github.com/w3c/resource-timing/issues/12
 */
var _ = require('lodash'),
  configs = require('../config/configManager'),
  s3Writer = require('./s3Writer'),
  cache = require('../models/cache'),
  uuid = require('uuid'),
  log = require('./logger').getLoggerInstance('Base.EndpointMonitor'),
  processedResource = [],
  performanceMetrics = require('./performanceMetrics');

var privateMethods = {
    monitorAllSongbirdResourcesLoaded: function () {
      var timings = performanceMetrics.getAllMatchingResourceDurations('songbird.js');

      _.each(timings, function (timing) {
        if (_.indexOf(processedResource, timing.name) === -1) {
          processedResource.push(timing.name);
          s3Writer.capture(privateMethods.getClientId(), timing.name, timing.duration, true, timing.fetchStart);
        }
      });
    },
    monitorResource: function (resourceUrl, wasSuccessful) {
      if (configs.getSystemConfig().enableEndpointMonitor) {
        if (_.indexOf(processedResource, resourceUrl) >= 0) {
          return;
        }

        log.debug("Monitored " + resourceUrl);
        var timing = performanceMetrics.getMatchingResourceDuration(resourceUrl);

        if (timing !== undefined) {
          processedResource.push(timing.name);
          wasSuccessful = wasSuccessful !== undefined ? wasSuccessful : false;
          s3Writer.capture(privateMethods.getClientId(), timing.name, timing.duration, wasSuccessful, timing.fetchStart);
        }
      }
    },
    getClientId: function () {
      if (cache.consumerSessionId !== undefined) {
        return 'mcsId-' + cache.consumerSessionId;
      }

      if (cache.jti !== undefined) {
        return 'jti-' + cache.jti;
      }

      return 'AutoGenerated-' + uuid.v4();
    }
  },
  publicMethods = {
    /**
     * Initializes the s3 writer and attaches the load event for getting resource timings
     * @param {object} window - the browser window
     */
    initialize: function (window) {
      if (configs.getSystemConfig().enableEndpointMonitor) {
        s3Writer.initialize(window, configs.getSystemConfig().logging.s3Writer.url, 'EndpointMonitor',
          'Endpoint Monitor');

        privateMethods.monitorResource('/songbird.js');
      }
    },
    /**
     * Sends the chunk timing data to the s3 writer
     * @param {string} chunkName - the songbird chunk being monitored
     * @param {bool} chunkNotSongbird - identifies if the chunk is a songbird chunk
     */
    captureTiming: function (chunkName, chunkNotSongbird) {
      if (chunkNotSongbird || chunkName.indexOf('songbird.js') > -1) {
        privateMethods.monitorResource(chunkName);
      } else {
        privateMethods.monitorAllSongbirdResourcesLoaded();
      }
    },
    /**
     * Sends the s3 writer log data
     * @param {string} action - the event data for the capture
     * @param {number} runTime - the elapsed time in milliseconds for the event being captured
     * @param {boolean} wasSuccessful - flag to indicate if the result of the attempted action was successful
     * @param {number} redirectCount - if applicable, the number of redirects involved in the current timing process 
     */
    capture: function (action, runtime, wasSuccessful, redirectCount) {
      s3Writer.capture(privateMethods.getClientId(), action, runtime, wasSuccessful, null, redirectCount);
    },
    /**
     * Sends the Xhr timing data to the s3 writer
     * @param {string} url - url to monitor
     * @param {boolean} wasSuccessful - flag to indicate if the result of the xhr was successful
     */
    captureXhr: function (url, wasSuccessful) {
      privateMethods.monitorResource(url, wasSuccessful);
    },
    /**
     * Sends all endpoint monitor requests to the s3 writer
     */
    flushAll: function () {
      log.debug("Flushing resource timings");
      s3Writer.flushAll();
    }
  };

module.exports = publicMethods;


//////////////////
// WEBPACK FOOTER
// ./libraries/endpointMonitor.js
// module id = 63
// module chunks = 0 5 20